import React from "react";
import ReactECharts from "echarts-for-react";

import { SkeletonChart } from "./skeletons/productDetail";

// Modifica esta función para manejar ambos conjuntos de datos
export const processChartData = (apiData, valuacionesBenchmark, fondoName, benchmarkName) => {
    // Extrae las fechas para el eje X y los valores de vcp para el eje Y de apiData
    const xAxisData = apiData.map((data) => data.fecha);
    const seriesData = [
        {
            data: apiData.map((data) => {
                return data.vcp;
            }),
            type: "line",
            name: fondoName, // Nombre de la primera serie
        },
    ];

    // Si valuacionesBenchmark está presente, procesa esos datos también
    if (valuacionesBenchmark && valuacionesBenchmark.valuaciones.length > 0) {
        const benchmarkData = valuacionesBenchmark.valuaciones;
        seriesData.push({
            data: benchmarkData.map((data) => data.vcp),
            type: "line",
            name: benchmarkName, // Nombre de la segunda serie
        });
    }

    return { xAxisData, seriesData };
};

export function BenchmarkChart({ fondoName, fondoData, benchmarkData, benchmarkName }) {
    if (!fondoData) {
        return <SkeletonChart />;
    }

    const { xAxisData, seriesData } = processChartData(fondoData, benchmarkData, fondoName, benchmarkName);

    const options = {
        grid: { top: 24, right: 40, bottom: 80, left: 80 },
        xAxis: {
            type: "category",
            data: xAxisData,
        },
        yAxis: {
            type: "value",
        },
        series: seriesData, // Aquí se usa el array de seriesData
        tooltip: {
            trigger: "axis",
        },
        dataZoom: [
            {
                type: "inside",
                xAxisIndex: [0],
                start: 0,
                end: 100,
            },
            {
                type: "slider",
                xAxisIndex: [0],
                start: 0,
                end: 100,
            },
            {
                type: "inside",
                yAxisIndex: [0],
                start: 0,
                end: 100,
            },
            {
                type: "slider",
                yAxisIndex: [0],
                start: 80,
                end: 100,
                right: 0,
            },
        ],
        toolbox: {
            feature: {
                dataZoom: {
                    yAxisIndex: "none",
                },
                restore: {},
                saveAsImage: {},
            },
        },
    };

    return (
        <div className="cot-lines-chart">
            <ReactECharts option={options} />
        </div>
    );
}
